module.exports = __webpack_public_path__ + "img/icon-chat.14b71fe0.svg";